import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../src/components/Layout';
import { getHeader, getFooter } from '../src/adapters/contentful.adapter';
import style from '../styles/fiftyfive.scss';
import RippleMockTleMagic from '../src/components/RippleMockTLE/RipplemockMagic';
import RipplesignPopUp from './ripplemocksignpopup';

const RippleMockMagic = (props) => {
    const { pageInfo } = props;
    const isRipplePage = typeof window !== 'undefined' && (window.location.pathname === '/magic-shorts/' || window.location.pathname === '/magic-shorts');
    return (
        <div className="fiftyfiveplus">
            <Layout header={false} footer={false} pageInfo={pageInfo}>
                <div className="content-wrapper ripple-mock-container">
                    <RippleMockTleMagic />
                    <RipplesignPopUp isRipplePage={isRipplePage} />
                </div>
            </Layout>
            <style jsx>{style}</style>
        </div>
    );
};
RippleMockMagic.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();
    return {
        header,
        footer,
        pageInfo: { breadcrumbsTitle: 'キャンペーン',
            title: 'UI（尿もれ）のお悩みありませんか？',
            description:
     '尿もれのことって誰かに聞きにくいしという方はいませんか。尿もれのタイプや骨盤底筋を鍛えて改善するトレーニング方法をご紹介。あなたにあった商品診断もできますのでお悩みの方はぜひご利用ください。',
            url: '/senior-urinary-incontinence-guide',
            ogTitle: 'UI（尿もれ）のお悩みありませんか？',
            ogType: 'website',
            ogDescription:
     '尿もれのことって誰かに聞きにくいしという方はいませんか。尿もれのタイプや骨盤底筋を鍛えて改善するトレーニング方法をご紹介。あなたにあった商品診断もできますのでお悩みの方はぜひご利用ください。',
            ogImage:
     { url:
        'https://images.ctfassets.net/8g0fievzqg8k/1xYSc0d2UTlal28HNKCF5S/f2454808263615cb9d7944c6025f6137/KOI_OPG_kv.jpg',
     width: 1201,
     height: 631,
     contentType: 'image/jpeg' },
            canonicals: { items: [{ canonical: 'https://www.whisper.jp/magic-shorts' }] } },
    };
};
RippleMockMagic.propTypes = {
    pageInfo: PropTypes.object,
};
export default RippleMockMagic;
